module.exports = __webpack_public_path__ + "static/media/Greninja.5c767f93.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Greninja.png
// module id = 67
// module chunks = 0